import { FC } from 'react';
import { isMobile } from 'react-device-detect';
import { useState } from '@hookstate/core';
import { BingoCardListMobile } from '../../components/BingoCardList/mobile';
import { BingoCardListDesktop } from '../../components/BingoCardList/desktop';
import { useCardListVisible } from '../../hooks/use-card-list-visible';
import { useCountdown } from '../../hooks/use-countdown';
import { useGamePart } from '../../hooks/use-game-part';
import { useGameType } from '../../hooks/use-game-type';
import {
    calls,
    current,
    fireBallStatus,
    meta,
    next,
    ticketWins,
} from '../../stores/backend';
import { ticketCardId } from '../../lib/confirmed-wins';
import { getQuery } from '../../lib/query';

export const BingoCardList: FC = () => {
    const $current = useState(current);
    const $next = useState(next);
    const $calls = useState(calls);
    const $meta = useState(meta);
    const $fireBallStatus = useState(fireBallStatus);
    const $ticketWins = useState(ticketWins);

    const { isVisible, isCurrent, game, cards } = useCardListVisible(
        $current,
        $next,
        $calls,
        $meta
    );

    const gameType = useGameType(game);
    const called = isCurrent ? $calls.value : [];
    const { patterns, matches } = useGamePart(game, $meta);
    const { seconds } = useCountdown(new Date($meta.timer.date.value));

    const hasFreeSpace = game.game_hasFreeSpace.value;
    const hasBallCallsStarted = isCurrent && $calls.value.length > 0;
    const isSalesClosedCountdown = seconds > 0 && seconds <= 20;
    const isGameMode = game.game_mode.value === 'GAME_MODE';
    const isTicketSalesClosed = isSalesClosedCountdown || isGameMode;
    const shouldShowFireBallOnCards =
        hasBallCallsStarted || isTicketSalesClosed;
    const fireBall = shouldShowFireBallOnCards
        ? game.fireball?.value
        : undefined;

    const Component = isMobile ? BingoCardListMobile : BingoCardListDesktop;

    if (isVisible === false) {
        return null;
    }

    return (
        <Component
            cards={cards}
            confirmedCardIds={
                isCurrent &&
                $ticketWins.gameSessionId.value === game.game_sid.value
                    ? $ticketWins.records.value
                          .filter(
                              (winner) =>
                                  String(winner.userId) ===
                                      String(getQuery().USERID) &&
                                  winner.part === game.current_part.value + 1
                          )
                          .map((winner) => ticketCardId(winner.cardId))
                    : []
            }
            called={called}
            matches={matches}
            gameType={gameType}
            patterns={patterns}
            hasFreeSpace={hasFreeSpace}
            fireBall={fireBall}
            fireBallSnuffed={
                shouldShowFireBallOnCards &&
                isCurrent &&
                $fireBallStatus.value === 'snuffed'
            }
            autoDaub={$meta.autoDaub.value}
            dauberColor={$meta.dauberColor.value}
            dauberStyle={$meta.dauberStyle.value}
            currentPart={game.current_part.value}
        />
    );
};
